module.exports = __webpack_public_path__ + "img/Group_27996@2x.eee687b5.png";